import { Box, Typography } from "@mui/material";
import IntegrationImage from "../../../stack/integrations/components/IntegrationImage";
import { IntegrationsMapping } from "../../../stack/integrations/IntegrationsMapping";

const IntegrationRowFilter = ({ name, label = "" }) => {
  return (
    <Box
      display={"flex"}
      flexDirection={"row"}
      alignItems={"center"}
      justifyContent={"space-around"}
    >
      <IntegrationImage name={name} width="30px" showToolTip={false} />
      <Typography
        variant="caption"
        style={{ textTransform: "none", fontSize: "12px", paddingLeft: "8px" }}
      >
        {label ? label : IntegrationsMapping[name].displayName}
      </Typography>
    </Box>
  );
};

export default IntegrationRowFilter;
